import { render } from "./YourPetsPage.vue?vue&type=template&id=37d8e41e&scoped=true"
import script from "./YourPetsPage.vue?vue&type=script&lang=js"
export * from "./YourPetsPage.vue?vue&type=script&lang=js"

import "./YourPetsPage.vue?vue&type=style&index=0&id=37d8e41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d8e41e"]])

export default __exports__